module.exports = __webpack_public_path__ + "img/logo-large.230d7e64.svg";